var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRooms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65 0.00977954C6 -0.0402205 6.25 0.099771 6.29 0.469771V13.0898C6.29 13.3598 6.06 13.5698 5.79 13.5598L0.299999 12.0898C0.159999 12.0298 0.0799988 11.9298 0.0299988 11.7898L0 1.91977C0.01 1.70977 0.13 1.52978 0.33 1.45978L5.66 0.00977954H5.65ZM5.32 1.11978L0.959999 2.31978V11.2598L5.32 12.4398V1.11978Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70981 11.1393V2.42934H7.63981C7.55981 2.42934 7.37981 2.28933 7.33981 2.21933C7.12981 1.88933 7.33981 1.49934 7.72981 1.45934C7.99981 1.43934 8.51981 1.43934 8.78981 1.45934C9.19981 1.49934 9.49981 1.74933 9.63981 2.12933C9.74981 5.12933 9.64981 8.14933 9.68981 11.1593C9.66981 11.5693 9.41981 11.9393 9.01981 12.0693C8.79981 12.1393 7.91981 12.1493 7.67981 12.1093C7.24981 12.0493 7.10981 11.4593 7.47981 11.2193C7.49981 11.1993 7.62981 11.1393 7.64981 11.1393H8.71981H8.70981Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76957 5.81982C4.05957 5.76982 4.31957 5.94982 4.34957 6.24982C4.36957 6.46982 4.37957 7.17981 4.33957 7.38981C4.22957 7.88981 3.44957 7.86981 3.38957 7.30981C3.36957 7.08981 3.35957 6.37981 3.39957 6.16981C3.42957 5.99981 3.59957 5.83982 3.76957 5.81982Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRooms);
export default __webpack_public_path__ + "static/media/rooms.aa9aa56485d8e78324a30115dfcb3a7d.svg";
export { ForwardRef as ReactComponent };